/** @format */
import { UseQueryOptions, useQuery } from '@tanstack/react-query';

import { getSimilarModelRecommendationsQueryKey } from '@toucan/common/features/recommendations';

import { Milliseconds } from '@toucan/client/global/application';
import { MarketCode } from '@toucan/client/global/market';

import { getSimilarModelRecommendations } from '@toucan/client/core/recommendations';

export const useSimilarModelRecommendations = (
    modelIds: number[],
    market: MarketCode,
    options: Pick<UseQueryOptions, 'enabled'> = { enabled: true }
) => {
    // eslint-disable-next-line @tanstack/query/exhaustive-deps -- Legacy code: do not use as an example.
    return useQuery({
        queryKey: getSimilarModelRecommendationsQueryKey(modelIds),
        enabled: options.enabled && Boolean(modelIds.length),
        queryFn: () => getSimilarModelRecommendations(modelIds, market),
        staleTime: Milliseconds.ONE_HOUR,
    });
};
